module.exports = __webpack_public_path__ + "img/ggl1.8a787492.png";